import { useCommonWidgetHandlers } from './use-common-widget-handlers';
import * as Widgets from '@mm/constants/widgets';

export const useDelayWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();

  const addNew = (dialogueId: number, sortOrder: number) => {
    const newWidget = {
      pageId: dialogueId,
      type: Widgets.DELAY,
      label: '',
      sortOrder,
      config: {
        value: 5,
        measure: 'minute',
      },
    };

    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    delete: commonWidgetHandlers.delete,
    addNew,
  };
};
